import * as THREE from 'three'

class USPMarker {

  /**
   *
   * @type {THREE.Texture}
   * @private
   */
  _texture = null

  visible = false

  /**
   *
   * @type {THREE.SpriteMaterial}
   * @private
   */
  _material = null
  _actionMaterial = null

  /**
   *
   * @type {THREE.Sprite}
   * @private
   */
  _spite = null
  _actionSprite = null

  _cameraPoint = null
  /**
   *
   * @type {Three.ArrowHelper}
   * @private
   */
  _arrowHelper = null
  _carModel = null
  _threeWrapper = null
  _cube = null
  /**
   *
   * @type {THREE.Vector3}
   */
  position = null

  /**
   *
   * @type {Raycaster}
   * @private
   */
  _raycaster = new THREE.Raycaster()
  _isMobile = false
  selected = false

  constructor(cameraPoint, threeWrapper) {
    this._threeWrapper = threeWrapper
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    this._isMobile = toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });

    let scene = this._threeWrapper.scene
    this._cameraPoint = cameraPoint
    const loader = new THREE.TextureLoader()

    if (cameraPoint.markerPosition) {
      this.position = cameraPoint.markerPosition
      loader.load(require('@/assets/images/car-configurator/3d-icons/dot.png'), (texture) => {
        this._texture = texture
        this._texture.encoding = THREE.sRGBEncoding
        this._material = new THREE.SpriteMaterial({
          map: this._texture,
          color: 0xffffff,
          opacity: 1,
          depthWrite: false,
          depthTest: false,
          sizeAttenuation: false
        })

        this._spite = new THREE.Sprite(this._material)
        this._spite.name = this._cameraPoint.name
        this._spite.renderOrder = 0;

        this._spite.position.set(this.position.x, this.position.y, this.position.z)
        this._spite.scale.set(0.02, 0.02, 1)

        if (this._cameraPoint.name !== 'full-car') scene.add(this._spite)
      })
    }

    if (this._cameraPoint.actionMarkerPosition) {
      this.position = this._cameraPoint.actionMarkerPosition
      loader.load(require('@/assets/images/car-configurator/3d-icons/' + this._cameraPoint.name + '.png'), (actionTexture) => {
        actionTexture.encoding = THREE.sRGBEncoding
        this._actionMaterial = new THREE.SpriteMaterial({
          map: actionTexture,
          color: 0xffffff,
          opacity: 1,
          depthWrite: false,
          depthTest: false,
          sizeAttenuation: false,
        })

        this._actionSprite = new THREE.Sprite(this._actionMaterial)
        this._actionSprite.name = this._cameraPoint.name
        this._actionSprite.renderOrder = 0;

        this._actionSprite.position.set(this._cameraPoint.actionMarkerPosition.x, this._cameraPoint.actionMarkerPosition.y, this._cameraPoint.actionMarkerPosition.z)
        this._actionSprite.scale.set(0.04, 0.04, 1)

        if (this._cameraPoint.name !== 'full-car') scene.add(this._actionSprite)

        // scene.add(this._arrowHelper)
      })
    }

    let material = new THREE.SpriteMaterial({
      map: null,
      color: 0xffffff,
      opacity: 0,
      depthWrite: false,
      depthTest: false,
      sizeAttenuation: false,
    })

    let clickSprite =  new THREE.Sprite(material)
    clickSprite.name = this._cameraPoint.name
    clickSprite.enderOrder = 0
    clickSprite.position.set(this.position.x, this.position.y, this.position.z)
    clickSprite.scale.set(0.05, 0.05, 1)

    scene.add(clickSprite)
  }

  getSprite() {
    return this._spite ? this._spite : this._actionSprite
  }

  updateAlpha(zoom) {
    if (this._actionSprite || this._spite) {
      if (!this._carModel) {
        this._carModel = new THREE.Mesh()
        let geometry = new THREE.BoxGeometry(1.8, 1.3, 4)
        let material = new THREE.MeshBasicMaterial({color: 0x000000, opacity: 0, transparent: false})
        this._carModel = new THREE.Mesh(geometry, material)
        this._carModel.visible = false
        this._threeWrapper.scene.add(this._carModel)
        this._carModel.position.set(0, 0.7, 0)

        let geometry2 = new THREE.BoxGeometry(0.1, 0.1, 0.1)
        let material2 = new THREE.MeshBasicMaterial({color: 0x000000, opacity: 0, transparent: true})
        this._cube = new THREE.Mesh(geometry2, material2)
        // this._threeWrapper.scene.add(this._cube)
        this._cube.position.set(this.position.x, this.position.y, this.position.z)

      } else {

        this._cube.lookAt(this._threeWrapper.camera.position)

        let direction = new THREE.Vector3()
        this._cube.getWorldDirection(direction)

        if (this._spite) {
          this._spite.lookAt(this._threeWrapper.camera.position)
          this._raycaster.set(this.position.clone(), direction)

          let list = this._raycaster.intersectObjects([this._carModel], true)
          let toOpacity = list.length > 0 && !this._cameraPoint.insideCabine ? 0.3 : 1
          this._cameraPoint.opacity = toOpacity
          this._material.opacity += (toOpacity - this._material.opacity) / 10

          if (Math.abs(toOpacity - this._material.opacity) > 0.01) {
            this.someUpdated = true
          }

          // console.log(zoom)
          let scale = (this._threeWrapper.camera.fov > 55 ? 0.038 : 0.038)
          if (!this.selected) {
            scale = this.visible ? 0.1 : 0

            if (zoom < 0.4) {
              scale = 0.065
            } else {
              const zoomPercents = zoom / 6.5
              scale = scale - zoomPercents * 0.07
            }
          } else {
            scale = 0
          }

          if (!this.visible) scale = 0

          this._spite.scale.set(scale, scale,1)

        }

        if (this._actionSprite) {
          this._actionSprite.lookAt(this._threeWrapper.camera.position)
          this._raycaster.set(this._actionSprite.position.clone(), direction)

          if (this._cameraPoint.name === 'door-actions') console.log(list)

          let list = this._raycaster.intersectObjects([this._carModel], true)
          let toOpacity = list.length > 0 ? 0.3 : 1

          if (this._actionMaterial) this._actionMaterial.opacity += (toOpacity - this._actionMaterial.opacity) / 10

          if (Math.abs(toOpacity - this._actionMaterial.opacity) > 0.01) {
            this.someUpdated = true
          }

          let scale = this.visible ? (this._isMobile ? 0.05 : 0.038) : 0
          this._actionSprite.scale.set(scale, scale, 1)
        }
      }
    }
  }
}

class CameraController {
  /**
   *
   * @type {ThreeWrapper}
   */
  threeWrapper = null

  someUpdated = false

  selectedUsp = null

  cabineAnimationComplete = true
  insideCabine = false
  cabineRotationDestinated = false
  cameraWorldPosition = new THREE.Vector3()
  containerQuaternion = new THREE.Quaternion()
  jointQuaternion = new THREE.Quaternion()
  cameraZoomPosition = new THREE.Vector3()

  cameraOrbit = {
    light: new THREE.PointLight(0xaaaaff, 2),
    cameraFlySpeed: 0.5,
    flySpeed: 0.1,
    positionSpeed: 0,
    autoRotation: true,
    mouseCaptured: false,
    lookAtVector: null,
    toLookAtVector: null,
    container: null,
    joint: null,
    cameraPoint: null,
    jointAngle: - Math.PI / 10,
    touches: [],
    toZoom: 0,
    zoom: 0,
    lookVector: null,
    defLookVector: null,
    zoomLimit: {
      min: 3,
      max: 6
    },
    angles: {
      outsideCabine: {
        min: -0.6,
        max: -0.1
      },
      insideCabine: {
        min: -0.5,
        max: -0.1
      }
    }
  }

  get zoomLimit() {
    return this.insideCabine ? {
      min: 0.000001,
      max: 0.32
    } : {
      min: 3,
      max: 6.5
    }
  }

  _currentPoint = null
  _rotationDestinated = false
  onPointsUpdated = null
  onPointClick = null

  _raycaster = new THREE.Raycaster()

  _cameraPoints = [
    {
      name: 'full-car',
      static: false,
      markerPosition: new THREE.Vector3(0, 2.5, 0),
      containerRotation: new THREE.Euler(0, -Math.PI / 4.8, 0),
      jointAngle: -0.27,
      zoom: 6.5,
      screenPosition: {
        x: 0,
        y: 0
      }
    },
    {
      name: 'roof',
      static: false,
      markerPosition: new THREE.Vector3(0.3 , 1.7, 0.5),
      containerRotation: new THREE.Euler(0, Math.PI / 3, 0),
      jointAngle: - Math.PI / 4,
      zoom: 5,
    },
    {
      name: 'door',
      static: false,
      markerPosition: new THREE.Vector3(-1, 1.1, -0.2),
      containerRotation: new THREE.Euler(0, -Math.PI / 2, 0),
      jointAngle: -0.4,
      zoom: 5
    },
    // {
    //   name: 'door-action',
    //   actionMarkerPosition: new THREE.Vector3(-1, 1.1, 0),
    //   jointAngle: 0
    // },
    {
      name: 'trunk',
      static: false,
      markerPosition: new THREE.Vector3(0, 0.82, -2.3),
      containerRotation: new THREE.Euler(0, -Math.PI, 0),
      jointAngle: -0.25,
      zoom: 5
    },
    // {
    //   name: 'trunk-action',
    //   actionMarkerPosition: new THREE.Vector3(-0.75, 1.25, -2.1),
    // },
    // {
    //   name: 'camera',
    //   static: true,
    //   markerPosition: new THREE.Vector3(0, 1.2, -2.3),
    //   position: new THREE.Vector3(0.5, 0.8, -4),
    //   lookAtVector: new THREE.Vector3(0.5, 0.6  , 0),
    //   containerRotation: new THREE.Euler(0, -Math.PI / 3, 0),
    //   zoom: {
    //     min: 1,
    //     max: 1
    //   },
    //   angles: {
    //     min: -0.4,
    //     max: -0.1
    //   }
    // },
    {
      name: 'adaptive-cruise',
      static: false,
      markerPosition: new THREE.Vector3(-0.2, 0.7, 2.3),
      containerRotation: new THREE.Euler(0, 0, 0),
      jointAngle: -0.25,
      zoom: 4
    },
    {
      name: 'distation-system',
      static: false,
      markerPosition: new THREE.Vector3(0.2, 0.82, 2.3),
      containerRotation: new THREE.Euler(0, Math.PI / 20, 0),
      jointAngle: -0.25,
      zoom: 4
    },
    {
      name: 'lights',
      static: false,
      markerPosition: new THREE.Vector3(-0.8, 0.7, 2),
      containerRotation: new THREE.Euler(0, -Math.PI / 10, 0),
      jointAngle: -0.25,
      zoom: 3
    },
    // {
    //   name: 'lights-action',
    //   actionMarkerPosition: new THREE.Vector3(-0.5, 0.8, 2.3),
    // },
    {
      name: 'wheel-seats',
      static: false,
      markerPosition: new THREE.Vector3(0.3, 1, 0.5),
      containerRotation: new THREE.Euler(0, -Math.PI + Math.PI / 9, 0),
      jointAngle: -0.4,
      zoom: 0.1,
      insideCabine: true
    },
    {
      name: 'interior',
      static: false,
      markerPosition: new THREE.Vector3(0, 1, - 0.5),
      containerRotation: new THREE.Euler(0, 0, 0),
      jointAngle: -0.4,
      zoom: 0.1,
      insideCabine: true
    },
    {
      name: 'hud',
      static: false,
      markerPosition: new THREE.Vector3(0.46, 1.1, 0.7),
      containerRotation: new THREE.Euler(0, -Math.PI + Math.PI / 10, 0),
      zoom: 0.1,
      jointAngle: -0.3,
      insideCabine: true
    },
    {
      name: 'app-connect',
      static: false,
      markerPosition: new THREE.Vector3(-0.05, 1.2, 0.6),
      containerRotation: new THREE.Euler(0, -Math.PI - Math.PI / 15, 0),
      jointAngle: -0.2,
      zoom: 0.1,
      insideCabine: true
    },
    {
      name: 'ambient-light',
      static: false,
      markerPosition: new THREE.Vector3(-0.16, 0.95, 0.6),
      containerRotation: new THREE.Euler(0, -Math.PI - Math.PI / 10, 0),
      jointAngle: -0.5,
      zoom: 0.1,
      insideCabine: true,
    },
  ]

  setSelectedUsp(uspData) {
    this.selectedUsp = uspData
  }

  constructor({threeWrapper, onPointsUpdated, onPointClick}) {
    this.setThreeWrapper(threeWrapper)
    this.onPointsUpdated = onPointsUpdated
    this.onPointClick = onPointClick
  }

  setThreeWrapper (threeWrapper) {
    if (!this.threeWrapper) {
      this.threeWrapper = threeWrapper
      this.threeWrapper.addUpdateController(this)
      this.createOrbitContainer()

      this._cameraPoints.forEach(point => {
        const uspMarker = new USPMarker(point, this.threeWrapper)
        point.marker = uspMarker
      })

      this.setCameraPoint(this._cameraPoints[0])
    }
  }

  setCameraPoint(point) {
    let setted = false
    this._currentPoint = point

    if (point) {
      this._currentPoint = point
      this._rotationDestinated = false
      setted = true
    }

    return setted
  }

  setCameraPointByName(name) {
    this.cameraOrbit.autoRotation = false
    let founded = null
    if (!this._currentPoint || !this._currentPoint.name !== name) {
      for (const point of this._cameraPoints.values()) {
        if (point.name === name) {
          this.setCameraPoint(point)
          founded = point
          break
        }
      }
    }

    return founded
  }

  createOrbitContainer() {
    if (!this.cameraOrbit.container) {
      this.cameraOrbit.lookVector = new THREE.Vector3(0, 0, 0)
      this.cameraOrbit.defLookVector = new THREE.Vector3(0, 0, 0)

      this.cameraOrbit.container = new THREE.Mesh()
      this.threeWrapper.scene.add(this.cameraOrbit.container)

      this.cameraOrbit.container.name = 'CameraContainer'
      this.cameraOrbit.joint = new THREE.Mesh()
      this.cameraOrbit.joint.name = 'CameraJoint'
      this.cameraOrbit.cameraPoint = new THREE.Mesh() // new THREE.Mesh(new THREE.BoxGeometry( 1, 1, 1 ), new THREE.MeshBasicMaterial( {color: 0x00ff00} ))
      this.cameraOrbit.cameraPoint.name = 'CameraPoint'

      this.cameraOrbit.container.position.set(0, 0, 0)

      this.cameraOrbit.lookAtVector = new THREE.Vector3(0,0.5,0)
      this.cameraOrbit.toLookAtVector = new THREE.Vector3(0,0.5,0)

      this.cameraOrbit.container.add(this.cameraOrbit.joint)
      // this.cameraOrbit.joint.rotation.set(0, 0, 0)
      this.cameraOrbit.joint.position.set(0, 0, 0)

      this.cameraOrbit.joint.add(this.cameraOrbit.cameraPoint)

      this.cameraOrbit.toZoom = this._cameraPoints[0].zoom
      this.cameraOrbit.cameraPoint.position.set(0, 0, this.cameraOrbit.toZoom)

      this.cameraOrbit.joint.rotation.set(this.cameraOrbit.angles.outsideCabine.min, 0, 0)

      this.cameraOrbit.container.position.set(0, 0, 0)

      let vector = new THREE.Vector3()
      this.cameraOrbit.cameraPoint.getWorldPosition(vector)
      this.threeWrapper.camera.position.set(vector.x, vector.y, vector.z)
      this.threeWrapper.camera.lookAt(this.cameraOrbit.lookAtVector)

      // this.cameraOrbit.cameraPoint.add(this.cameraOrbit.light)
      // this.cameraOrbit.light.position.set(0,0,0)

      this.createTouchMouseEvents()
      this.updateCameraPosition()
    }
  }

  isMouseLocked () {
    return this._currentPoint && this._currentPoint.static
  }

  setInsideCabine() {
    if (!this.insideCabine) {
      this.cabineAnimationComplete = false
      this.insideCabine = true
      this._rotationDestinated = false
      this.cabineRotationDestinated = false
    }
  }
  setOutsideCabine() {
    if (this.insideCabine) {
      this.cabineAnimationComplete = false
      this.insideCabine = false
      this._rotationDestinated = false
      this.cabineRotationDestinated = false
    }
  }

  updateCameraPosition() {
    if (this.cameraOrbit.container) {
      this.cameraOrbit.cameraPoint.getWorldPosition(this.cameraWorldPosition)

      if (this.cameraOrbit.autoRotation) {
        this.cameraOrbit.container.rotateY(-Math.PI / 500)
        this.someUpdated = true
      } else {
        if (!this.cabineAnimationComplete) {
          const sceneCameraPosition = this.threeWrapper.camera.position
          const cameraPointPosition = new THREE.Vector3()
          this.cameraOrbit.cameraPoint.getWorldPosition(cameraPointPosition)

          const cameraDelta = sceneCameraPosition.distanceTo(sceneCameraPosition)

          let toRotation = new THREE.Quaternion()
          toRotation.setFromEuler(new THREE.Euler(0,  Math.PI / 2, 0))

          if (this.insideCabine) {
            if (!this.cabineRotationDestinated) {
              this.cameraOrbit.jointAngle = 0
              this.cameraOrbit.container.quaternion.slerp(toRotation, this.cameraOrbit.flySpeed)
              if (this.cameraOrbit.container.quaternion.angleTo(toRotation) < 0.01 && cameraDelta < 0.001) {
                this.cameraOrbit.toZoom = this.zoomLimit.max
                if (Math.abs(this.cameraOrbit.toZoom - this.cameraOrbit.zoom) < 0.05) {
                  this.cabineRotationDestinated = true
                }
              }
            } else {
              this.cameraOrbit.jointAngle = -0.32
              const angle = this._currentPoint && this._currentPoint.name !== 'full-car' ? this._currentPoint.containerRotation.y : -Math.PI
              const toRotation = new THREE.Quaternion().setFromEuler(new THREE.Euler(0, angle, 0))
              this.cameraOrbit.container.quaternion.rotateTowards(toRotation, this.cameraOrbit.flySpeed)
              if (this.cameraOrbit.container.quaternion.angleTo(toRotation) < 0.01) {
                this.cabineAnimationComplete = true
                this._rotationDestinated = false
              }
            }
          } else {
            this.cameraOrbit.jointAngle = -Math.PI / 15
            this.cameraOrbit.container.quaternion.slerp(toRotation, this.cameraOrbit.flySpeed)

            if (!this.cabineRotationDestinated) {
              if (this.cameraOrbit.container.quaternion.angleTo(toRotation) < 0.01 && cameraDelta < 0.001) {
                if (this.cameraOrbit.toZoom - this.cameraOrbit.zoom < 0.05 ) {
                  this.cabineRotationDestinated = true
                }
              } else {
                this.cameraOrbit.toZoom = 0.2
              }
            } else {
              this.cameraOrbit.toZoom = this.zoomLimit.min
              if (Math.abs(this.cameraOrbit.toZoom - this.cameraOrbit.zoom) < 0.2 ) {
                this.cabineAnimationComplete = true
                this.cabineAnimationComplete = true
                this._rotationDestinated = false
              }
            }
          }
        } else if (this._currentPoint && this._currentPoint.containerRotation && !this._rotationDestinated) {
          if (!this.insideCabine && this._currentPoint.insideCabine) {
            this.setInsideCabine()
          } else if (this.insideCabine && !this._currentPoint.insideCabine) {
            this.setOutsideCabine()
          }

          this.containerQuaternion.setFromEuler(this._currentPoint.containerRotation)
          this.cameraOrbit.container.quaternion.slerp(this.containerQuaternion, this.cameraOrbit.flySpeed)

          let toAngle = this._currentPoint.jointAngle ? this._currentPoint.jointAngle : - Math.PI / 3;

          this.cameraOrbit.jointAngle += (toAngle - this.cameraOrbit.jointAngle) * this.cameraOrbit.flySpeed

          this.cameraOrbit.toZoom = this._currentPoint.zoom

          this.someUpdated = true

          if (this.cameraOrbit.container.quaternion.angleTo(this.containerQuaternion) < 0.01 &&
            Math.abs(toAngle - this.cameraOrbit.jointAngle) < 0.05 &&
            Math.abs(this._currentPoint.zoom - this.cameraOrbit.zoom) < 0.1) {
            this.cameraOrbit.container.quaternion.setFromEuler(this._currentPoint.containerRotation)
            this._rotationDestinated = true
          }
        }
      }

      if (this.insideCabine) {
        this.cameraOrbit.container.position.lerp(new THREE.Vector3(0, 1.3, 0), this.cameraOrbit.flySpeed)
        this.cameraOrbit.toLookAtVector = this.cabineAnimationComplete ? new THREE.Vector3(0, 1.3, 0) : new THREE.Vector3(0, 1.3, 0.5)
      } else if (this.cabineAnimationComplete) {
        this.cameraOrbit.container.position.lerp(new THREE.Vector3(0, 0.2, 0), this.cameraOrbit.flySpeed)
        this.cameraOrbit.toLookAtVector = new THREE.Vector3(0, 0.2, 0)
      }

      this.jointQuaternion.setFromEuler(new THREE.Euler(this.cameraOrbit.jointAngle, 0, 0))
      this.cameraOrbit.joint.quaternion.slerp(this.jointQuaternion, this.cameraOrbit.flySpeed)

      let fovDelta = 0

      if (this.insideCabine && this.cabineAnimationComplete) {
        fovDelta = Math.abs(60 - this.threeWrapper.camera.fov)
        if (fovDelta > 0.1) {
          this.threeWrapper.camera.fov += (60 - this.threeWrapper.camera.fov) / 5
          this.threeWrapper.updateProjectionMatrix()
        }
      } else {
        fovDelta = Math.abs(this.threeWrapper._options.fov - this.threeWrapper.camera.fov)
        if (fovDelta > 0.1) {
          this.threeWrapper.camera.fov += (this.threeWrapper._options.fov - this.threeWrapper.camera.fov) / 5
          this.threeWrapper.updateProjectionMatrix()
        }
      }

      this.threeWrapper.camera.position.lerp(this.cameraWorldPosition, this.cameraOrbit.cameraFlySpeed)
      //this.threeWrapper.camera.position.set(vector.x, vector.y, vector.z)

      this.cameraOrbit.zoom += (this.cameraOrbit.toZoom - this.cameraOrbit.zoom) * (this.cameraOrbit.flySpeed / 2)

      this.cameraZoomPosition.set(0,0, this.cameraOrbit.zoom)
      this.cameraOrbit.cameraPoint.position.set(this.cameraZoomPosition.x, this.cameraZoomPosition.y, this.cameraZoomPosition.z)
      this.cameraOrbit.lookAtVector.lerp(this.cameraOrbit.toLookAtVector, this.cameraOrbit.flySpeed / 2)
      this.threeWrapper.camera.lookAt(this.cameraOrbit.lookAtVector)
    }
  }


  /**
   * Update action for run animation of ThreeWrapper
   */
  update() {
    this.updateCameraPosition()
    this.updateMarkersOpacity()
    this.updatePointsScreenPosition()
  }

  updatePointsScreenPosition () {
    const visiblePoints = []
    let rect = this.threeWrapper.renderer.domElement.getBoundingClientRect()
    let widthHalf = rect.width / 2
    let heightHalf = rect.height / 2

    const destRotation = new THREE.Quaternion();

    this._cameraPoints.forEach(item => {
      if (item.markerPosition && item.name !== 'full-car') {
        let projectVector = item.markerPosition.clone().project(this.threeWrapper.camera)

        projectVector.x = (projectVector.x * widthHalf) + widthHalf + rect.x;
        projectVector.y = -(projectVector.y * heightHalf) + heightHalf;
        projectVector.z = 0;

        item.screenPosition = projectVector
        destRotation.setFromEuler(item.containerRotation)
        if (destRotation.angleTo(this.cameraOrbit.container.quaternion) < Math.PI / 3) {
          visiblePoints.push(item)
        }
      }
    })

    if (this.onPointsUpdated) this.onPointsUpdated(visiblePoints)
  }

  updateMarkersOpacity() {
    this._cameraPoints.forEach(point => {
      if (point.marker) {
        point.marker.selected = this.selectedUsp && this.selectedUsp.pointName === point.name
        if (!this.cabineAnimationComplete) {
          point.marker.visible = false
        } else {
          point.marker.visible = point.insideCabine ? this.insideCabine : !this.insideCabine
        }

        point.marker.updateAlpha(this.cameraOrbit.zoom)
      }
    })
  }


  reset () {
    this.cameraOrbit.mouseCaptured = false
    this.cameraOrbit.autoRotation = true
  }

  setZoomLimit({min, max, toZoom}) {
    this.cameraOrbit.zoomLimit.min = min
    this.cameraOrbit.zoomLimit.max = max
    this.cameraOrbit.toZoom = toZoom
  }

  updateZoomLimit () {
    // let width = window.innerWidth
    // if (width < 550) {
    //   this.cameraOrbit.cameraPoint.position.setZ(14)
    // } else if (width < 700) {
    //   this.cameraOrbit.cameraPoint.position.setZ(9)
    // } else {
    //   this.cameraOrbit.cameraPoint.position.setZ(7.3)
    // }
    //
    // if (window.innerWidth < 800) {
    //   this.setZoomLimit({
    //     min: 7.0,
    //     max: 20.0,
    //     toZoom: 19.0
    //   })
    // } else {
    //   this.setZoomLimit({
    //     min: 6.0,
    //     max: 12.0,
    //     toZoom: 8.0
    //   })
    // }
  }

  setZoom(z) {
    if (z < this.zoomLimit.min) {
      z = this.zoomLimit.min
    } else if (z > this.zoomLimit.max) {
      z = this.zoomLimit.max
    }

    this.cameraOrbit.toZoom = z
  }

  zoom(distance) {
    if (this.cameraOrbit.cameraPoint) {
      let vector = this.cameraOrbit.cameraPoint.position.clone()
      let z = vector.z - distance

      this.setZoom(z)
    }
  }

  createTouchMouseEvents() {
    this.threeWrapper.renderer.domElement.addEventListener('mousedown', this.onMouseDown.bind(this))
    this.threeWrapper.renderer.domElement.addEventListener('touchstart', this.onTouchStart.bind(this))

    document.addEventListener('mouseup', this.onMouseUp.bind(this))
    document.addEventListener('mousemove', this.onMouseMove.bind(this))
    document.addEventListener('mousewheel', this.onMouseWheel.bind(this), { passive: false })

    document.addEventListener('touchend', this.onTouchEnd.bind(this))
    document.addEventListener('touchcancel', this.onTouchEnd.bind(this))
    document.addEventListener('touchmove', this.onTouchMove.bind(this))


    window.addEventListener('resize', this.updateZoomLimit.bind(this))
  }

  onTouchStart(e) {
    this.someUpdated = true
    this.cameraOrbit.autoRotation = false
    this.cameraOrbit.mouseCaptured = true

    e.touches.forEach(touch => {

      if (e.touches.length === 1) {
        let mouse = new THREE.Vector2()
        let rect = this.threeWrapper.renderer.domElement.getBoundingClientRect()

        let touch = e.touches[0]
        mouse.x = ( touch.clientX / rect.width ) * 2 - 1;
        mouse.y = - ( (touch.clientY - rect.y) / rect.height ) * 2 + 1;

        this._raycaster.setFromCamera(mouse, this.threeWrapper.camera)
        let list = this._raycaster.intersectObjects(this.threeWrapper.scene.children, true)
        for (let hit of list) {
          if (hit.object.type === 'Sprite') {
            let filtered = this._cameraPoints.filter(item => item.name === hit.object.name)
            if (filtered.length > 0 && this.onPointClick) this.onPointClick(filtered[0])
            break
          }
        }
      }

      if (touch.target === this.threeWrapper.renderer.domElement) {
        let existsList = this.cameraOrbit.touches.filter(item => item.id === touch.identifier)
        if (existsList.length > 0) {
          existsList[0].x = touch.pageX
          existsList[0].y = touch.pageY
        } else {
          this.cameraOrbit.touches.push({
            id: touch.identifier,
            x: touch.pageX,
            y: touch.pageY
          })
        }
      }
    })

    e.preventDefault()
  }

  onTouchEnd(e) {
    this.cameraOrbit.touches = []
    e.touches.forEach(touch => {
      this.cameraOrbit.touches.push({
        id: touch.id,
        x: touch.pageX,
        y: touch.pageY
      })
      //this.cameraOrbit.touches = this.cameraOrbit.touches.filter(item => item.id !== touch.identifier)
    })

    if (this.cameraOrbit.touches.length === 0) {
      this.cameraOrbit.mouseCaptured = false
    }
  }

  onTouchMove(e) {
    this.someUpdated = true
    if (e.touches.length === 1 && this.cameraOrbit.touches.length > 1) {
      let touch = e.touches[0]
      this.cameraOrbit.touches = [{
        id: touch.identifier,
        x: touch.pageX,
        y: touch.pageY
      }]
    }

    if (!this.isMouseLocked() && this.cameraOrbit.mouseCaptured) {
      if (this.cameraOrbit.touches.length === 1) {
        const rotateDirection = this.insideCabine ? -1 : 1

        let touchItem = this.cameraOrbit.touches[0]

        let delta = {
          x: touchItem.x - e.touches[0].pageX,
          y: touchItem.y - e.touches[0].pageY,
        }

        this.cameraOrbit.jointAngle += (rotateDirection * delta.y) * (Math.PI / 180) / 4

        if (this.insideCabine) {
          if (this.cameraOrbit.jointAngle > this.cameraOrbit.angles.insideCabine.max) {
            this.cameraOrbit.jointAngle = this.cameraOrbit.angles.insideCabine.max
          } else if (this.cameraOrbit.jointAngle < this.cameraOrbit.angles.insideCabine.min) {
            this.cameraOrbit.jointAngle = this.cameraOrbit.angles.insideCabine.min
          }
        } else {
          if (this.cameraOrbit.jointAngle > this.cameraOrbit.angles.outsideCabine.max) {
            this.cameraOrbit.jointAngle = this.cameraOrbit.angles.outsideCabine.max
          } else if (this.cameraOrbit.jointAngle < this.cameraOrbit.angles.outsideCabine.min) {
            this.cameraOrbit.jointAngle = this.cameraOrbit.angles.outsideCabine.min
          }
        }

        this.cameraOrbit.container.rotateY((rotateDirection * delta.x) * (Math.PI / 180) / 4)
        // this.cameraOrbit.joint.rotation.set(this.cameraOrbit.jointAngle, 0, 0)

        this.cameraOrbit.touches[0].x = e.touches[0].pageX
        this.cameraOrbit.touches[0].y = e.touches[0].pageY

      } else if (this.cameraOrbit.touches.length === 2 && !this.cameraOrbit.insideCabine) {
        let [firstTouch, secondTouch] = this.cameraOrbit.touches

        let currentFirstTouch = e.touches[0].identifier === firstTouch.id ? e.touches[0] : e.touches[1]
        let currentSecondTouch = e.touches[0].identifier === secondTouch.id ? e.touches[0] : e.touches[1]

        let prevDelta = Math.sqrt(Math.pow(firstTouch.x - secondTouch.x, 2) + Math.pow(firstTouch.y - secondTouch.y, 2))
        let currentDelta = Math.sqrt(Math.pow(currentFirstTouch.pageX - currentSecondTouch.pageX, 2) + Math.pow(currentFirstTouch.pageY - currentSecondTouch.pageY, 2))

        let distance = currentDelta - prevDelta
        this.zoom(distance / 2)

        firstTouch.x = currentFirstTouch.pageX
        firstTouch.y = currentFirstTouch.pageY

        secondTouch.x = currentSecondTouch.pageX
        secondTouch.y = currentSecondTouch.pageY
      }
    }
  }

  onMouseDown (event) {
    this.someUpdated = true
    let mouse = new THREE.Vector2()
    let rect = this.threeWrapper.renderer.domElement.getBoundingClientRect()

    mouse.x = ( (event.clientX - rect.x) / rect.width ) * 2 - 1;
    mouse.y = - ( (event.clientY - rect.y) / rect.height ) * 2 + 1;

    this._raycaster.setFromCamera(mouse, this.threeWrapper.camera)
    let list = this._raycaster.intersectObjects(this.threeWrapper.scene.children, true)
    for (let hit of list) {
      if (hit.object.type === 'Sprite') {
        let filtered = this._cameraPoints.filter(item => item.name === hit.object.name)
        if (filtered.length > 0 && this.onPointClick && filtered[0].marker.visible) this.onPointClick(filtered[0])
        break
      }
    }

    this.cameraOrbit.autoRotation = false
    this.cameraOrbit.mouseCaptured = true
  }

  onMouseUp () {
    this.cameraOrbit.mouseCaptured = false
  }

  onMouseMove(e) {
    if (!this.isMouseLocked() && this.cameraOrbit.mouseCaptured) {
      this.someUpdated = true
      const rotateDirection = this.insideCabine ? 1 : -1

      let {movementX, movementY} = e
      this.cameraOrbit.jointAngle += (movementY * rotateDirection) * (Math.PI / 180) / 4

      if (this.insideCabine) {
        if (this.cameraOrbit.jointAngle > this.cameraOrbit.angles.insideCabine.max) {
          this.cameraOrbit.jointAngle = this.cameraOrbit.angles.insideCabine.max
        } else if (this.cameraOrbit.jointAngle < this.cameraOrbit.angles.insideCabine.min) {
          this.cameraOrbit.jointAngle = this.cameraOrbit.angles.insideCabine.min
        }
      } else {
        if (this.cameraOrbit.jointAngle > this.cameraOrbit.angles.outsideCabine.max) {
          this.cameraOrbit.jointAngle = this.cameraOrbit.angles.outsideCabine.max
        } else if (this.cameraOrbit.jointAngle < this.cameraOrbit.angles.outsideCabine.min) {
          this.cameraOrbit.jointAngle = this.cameraOrbit.angles.outsideCabine.min
        }
      }

      this.cameraOrbit.container.rotateY( (movementX * rotateDirection) * (Math.PI / 180) / 4)
      // this.cameraOrbit.joint.rotation.set(this.cameraOrbit.jointAngle, 0, 0)

      // this.updateCameraPosition()
    }

    const mouse = new THREE.Vector2()
    let rect = this.threeWrapper.renderer.domElement.getBoundingClientRect()

    mouse.x = ( (e.clientX - rect.x) / rect.width ) * 2 - 1;
    mouse.y = - ( (e.clientY - rect.y) / rect.height ) * 2 + 1

    const markers = []
    this._cameraPoints.filter((point => {
      if (point.marker) {
        const sprite = point.marker.getSprite()
        if (sprite) markers.push(point.marker.getSprite())
      }
    }))

    this._raycaster.setFromCamera(mouse, this.threeWrapper.camera)
    let list = this._raycaster.intersectObjects(markers)
    this.threeWrapper.renderer.domElement.style.cursor = list.length > 0 ? 'pointer' : 'auto'

    this.someUpdated = true
  }

  onMouseWheel(e) {
    if (e.target instanceof HTMLCanvasElement) {
      this.someUpdated = true
      this.zoom(-e.deltaY / 3)
      e.preventDefault()
    }
  }
}

export default CameraController